import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import { purchaseTicket, fetchPaymentMethod, getPaymentMethod } from '../../../store/client'

import { NavigationContext } from '../../../shared/ui/NavigationController'
import { isValid, secondsToTime, capitalize, range } from '../../../shared/utilities/helpers'
import Button from '../../../shared/ui/Button'
import { formatValue } from '../../../shared/ui/TableData'
import InputField, { validateInput } from '../../../shared/ui/InputField'
import Section from '../../../shared/ui/Section'
import InfoSection from '../../../shared/ui/InfoSection'
import Link from '../../../shared/ui/Link'
import DialogBox from '../../../shared/ui/DialogBox'

import PaymentMethodForm from './PaymentMethodForm'

import { withStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import Avatar from '@material-ui/core/Avatar'
import ProviderIcon from '@material-ui/icons/School'

const styles = theme => ({
  root: {
  },
  detailLabel: {
    fontSize: theme.typography.body2.fontSize,
    color: '#888'
  },
  detailValue: {
    fontWeight: 600
  },
  courseTitle: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: 600
  },
  providerCard: {
    //padding: theme.spacing.unit * 2,    
  },
  providerCardAvatar: {
    width: theme.spacing(8),
    height: theme.spacing(8),    
  },
  providerCardName: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 600,
  },
})

const ProviderCard = ({ theme, classes, item, linkTo }) => {
  let image_url = item.primary_image_url || ''
    
  return (
    <div className={classes.providerCard}>
      <Link to={linkTo} target='_blank'>
        <Box display='flex' alignItems='center'>
          <Avatar className={classes.providerCardAvatar}>
            <ProviderIcon />
          </Avatar>
          <Box flexGrow={1} ml={1}>
            <Typography variant="body2" className={classes.providerCardName}>
              { item.name }
            </Typography>
          </Box>
        </Box>
      </Link>
    </div>
  )
}
const PublicClassOrderView = ({ theme, classes, publicClass, open=true, onSave, onClose, showDialog, purchaseTicket, user }) => {
  
  const navigationContext = useContext(NavigationContext)
  
  const [formData, setFormData] = useState({
    quantity: 1,
    payment_terms: user && user.companyInfo ? 'NET14' : 'CBD',
    participants: [{}],
    callback_url: window.location.origin.toString(),
  })
  
  const quantityOptions = Array.from(Array(4), (_, i) => i + 1)
  
  const [errorFields, setErrorFields] = useState({})
  
  const getParticipantError = (index, fieldName) => {
    if (errorFields.participants && index < errorFields.participants.length)
      return errorFields.participants[index][fieldName]
    return null
  }
  
  const onChange = (fieldName) => (value) => {
    let newFormData = {
      ...formData,
      [fieldName]: value
    }
    
    const quantity = newFormData.quantity
    
    // Increase participants array
    if (quantity != formData.participants.length) {
      let participants = [...formData.participants]
      if (quantity > formData.participants.length)
        while (participants.length < quantity)
          participants.push({})
      else
        participants.splice(quantity, participants.length - quantity)      
        
      newFormData.participants = participants
    }
    
    setFormData(newFormData)
  }

  const onParticipantChange = (index, fieldName) => (value) => {
    setFormData({
      ...formData,
      participants: formData.participants.map((p, i) => {
        if (index == i)
          return {
            ...p,
            [fieldName]: value
          }
        else
          return p
      })
    })    
  }  
    
  const validateAndSave = () => {
    let errors = {}    
    
    let participantsError=[]
    formData.participants.forEach(p => {
      let pErrors = {}
      if (!validateInput(p.first_name, true))
        pErrors.first_name = "First name is required"
      if (!validateInput(p.last_name, true))
        pErrors.last_name = "Last name is required"        
      if (!validateInput(p.email, true, 'email'))
        pErrors.email = "Invalid email"
      if (!validateInput(p.mobile_no, true))
        pErrors.mobile_no = "Mobile No is required"
        
      participantsError.push(pErrors)
    })
    
    if (participantsError.find(p => Object.keys(p).length > 0))
      errors.participants = participantsError
    
    setErrorFields(errors)
        
    if (Object.keys(errors).length > 0) {
      alert("Please fix all input warnings to continue.")
      return
    }

    if (user.companyInfo) {
      if(!formData.payment_terms){
        alert("You have to select payment terms")
        return
      }
    }

    if(publicClass.price_per_participant > 0) {
      if(!formData.payment_method){
        alert("You have to select payment method")
        return
      }
    }
    
    if (!formData.agree) {
      alert("You have to agree to Terms and Conditions")
      return
    }      
    
    navigationContext.showLoadingDialog(true)
    
    purchaseTicket(publicClass.uid, formData, () => {
      navigationContext.showLoadingDialog(false)
      navigationContext.showMessageDialog(true)
      navigationContext.setMessageDialog({title:'Congratulations!', description:'Registration successfull, please check your email for more information.'})
      onClose()
    }, () => {
      navigationContext.showLoadingDialog(false)
    })    
  }

  const cancel = () => {
    if (window.confirm("Discard form?"))
      onClose()
  }
  
  let infoItems = []
  infoItems.push({
    label: "Date/Time",
    value: (
      <>
        { moment(publicClass.training_date).format("DD MMM YYYY") }<br/>
        { secondsToTime(publicClass.start_time) } - 
        { secondsToTime(publicClass.end_time) }
      </>      
    )    
  })
  
  if (publicClass.delivery_method == 'online') {
    infoItems.push({ label: 'Delivery Type', value: `Online via ${publicClass.delivery_app || 'Zoom'}` })
  }
  else {
    infoItems.push({ label: 'Delivery Type', value: 
      <>
        Offline
        { publicClass.venue &&
          <>
            <Typography>
              Location: { publicClass.venue.state } - { publicClass.venue.line4 }
            </Typography>
            <Typography>
              Venue:  { publicClass.venue.in_house ? 'In House' : 'Arranged By PasarTrainer' }
            </Typography>
          </>              
        }
      </>

    })
  }
  
  infoItems.push({
    label: "Trainer",
    value: (    
      <Box display='flex'>
        <Link to={`/trainer/${publicClass.trainer.uid}`} target="_blank">
          <Box mr={2}>
            <Avatar style={{
                width: '60px',
                height: '60px'            
              }}
              src={publicClass.trainer.profile_picture_url}
            />
          </Box>
          <Typography>
            { publicClass.trainer.first_name } { publicClass.trainer.last_name }
          </Typography>
        </Link>
      </Box>
    )
  })  

  const buttonsAction = [
    <Button variant='contained' color='primary' onClick={validateAndSave}
      fullWidth>
        Order
    </Button>
  ]
  
  return (
    <DialogBox title='Order Public Class' show={showDialog} onClose={cancel} actionButtons={buttonsAction}>
      <Box display='flex' flexDirection='column' alignItems='stretched'>
        {/*
        <Section gutterBottom>
          <Typography variant='h4'>
            Order Public Class
          </Typography>
        </Section>
        */}
        <Section title="Class Detail" gutterBottom>
          <Section variant='subsection' gutterBottom>
            <Typography component='h6' className={classes.courseTitle}>
              { publicClass.course.name }
            </Typography>
          </Section>  
          { publicClass.course.provider &&
            <Section title="Training Provider" variant='subsection'>
              <ProviderCard theme={theme} classes={classes}
                item={publicClass.course.provider}
                linkTo={`/provider/${publicClass.course.provider.uid}`}
              />
            </Section>      
          }
        </Section>
        <InfoSection
          items={infoItems}
          gutterBottom
          />
        <Section title="Order Detail">
          <Box display='flex'>
            <Box flexGrow={1}>
              <Typography className={classes.detailLabel}>
                Price
              </Typography>
              <Box mt={1}>
                <Typography className={classes.detailValue}>
                  { publicClass.price_per_participant > 0 ?
                      <>
                      { formatValue(publicClass.price_per_participant,'currency') } /pax
                      </>
                      :
                      "FREE"
                  }
                </Typography>
              </Box>
            </Box>
            <Box flexGrow={1}>
              <Typography className={classes.detailLabel}>
                Quantity
              </Typography>
              <Box mt={1}>
                <InputField
                  fieldName='quantity'
                  type='option'
                  options={quantityOptions}
                  value={formData.quantity}
                  onChange={onChange('quantity')}
                  />                              
              </Box>
            </Box>
            <Box flexGrow={1}>
              <Typography className={classes.detailLabel}>
                Total
              </Typography>
              <Box mt={1}>
                <Typography className={classes.detailValue}>
                  { formatValue(formData.quantity * (publicClass.price_per_participant), 'currency') }              
                </Typography>
              </Box>
            </Box>
          </Box>        
        </Section>
        <Section title="Participant Details" gutterBottom>
          { formData.participants.map((p, index) => (
            <Section variant='subsection' title={`Participant ${index+1}`} gutterBottom>
              <InputField
                fieldName={`pax_${index}_first_name`}
                type='text'
                label='First Name'
                value={p.first_name}
                error={getParticipantError(index, 'first_name')}
                onChange={onParticipantChange(index, 'first_name')}
                />
              <InputField
                fieldName={`pax_${index}_last_name`}
                type='text'
                label='Last Name'
                value={p.last_name}
                error={getParticipantError(index, 'last_name')}
                onChange={onParticipantChange(index, 'last_name')}
                />
              <InputField
                fieldName={`pax_${index}_email`}
                type='text'
                label='Email'
                validation='email'
                value={p.email}
                error={getParticipantError(index, 'email')}
                onChange={onParticipantChange(index, 'email')}
                />
              <InputField
                fieldName={`pax_${index}_mobile_no`}
                type='text'
                label='Mobile No'
                value={p.mobile_no}
                error={getParticipantError(index, 'mobile_no')}
                onChange={onParticipantChange(index, 'mobile_no')}
                />              
            </Section>
            ))          
          }
        </Section>

        { user.companyInfo && publicClass.price_per_participant > 0 &&
          <Section title="Payment Term" gutterBottom>
            <InputField 
              type='radio'
              label=''
              name='payment_terms'
              options={[
                {value:'CBD', text:'Cash before delivery'},
                {value:'NET14', text:'Payment on 14 days'}
              ]}
              value={formData.payment_terms}
              onChange={(value) => {
                setFormData({
                  ...formData,
                  payment_terms:value
                })
              }}
            />
          </Section>
        }
        
        { publicClass.price_per_participant > 0 &&
          <Section title="Payment Method" gutterBottom>
            <PaymentMethodForm 
            formData={formData}
            publicClass={publicClass}
            user={user}
            onChange={(value) => {
              setFormData({
                ...formData,
                payment_method:value
              })
            }}
            />
          </Section>
        }

        <Section title="Confirmation" gutterBottom>
          <InputField
            fieldName='agree'
            type='checkbox'
            labelStyle={{ zIndex: 3 }}
            label={
              ( <Typography variant='body1'> I agree with PasarTrainer <Link style={{ textDecoration:'underline' }} to={'/page/terms-and-conditions'} target={'_blank'}>Terms and Conditions</Link> </Typography> )
            }
            value={formData.agree}
            onChange={onChange('agree')}
            />                                     
        </Section>            
      </Box>
    </DialogBox>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    purchaseTicket: (key, data, onComplete, onError) => {
      dispatch(purchaseTicket(key, data, onComplete, onError))
    }
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(PublicClassOrderView)
)
